import { useState } from 'react'
import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { PlusCircleLine16 } from '@makyoapp/makyo-icon/icon'
import { DropdownV2, Modal } from '@makyoapp/makyo-ui'

import { CreateColumnProvider } from '@/context/CreateColumnContext'

import { useGridV2Context } from '../../contexts/GridV2Context'
import { ColumnForm } from '../form/ColumnForm'

export const GridAddColumnMenu = () => {
  const { table } = useGridV2Context()
  const isDisabled = table?.isSnapshot

  const [opened, setOpened] = useState(false)

  const handleOpenChange = (open: boolean) => {
    if (isDisabled) return
    setOpened(open)
  }

  return (
    <DropdownV2 open={opened} onOpenChange={handleOpenChange}>
      <DropdownV2.Trigger asChild>
        <div
          className={clsx(
            'h-full w-[60px]',
            'bg-zinc-50 dark:bg-slate-600',
            'border-l border-b border-zinc-200 dark:border-slate-700',
            'flex items-start justify-center',
            isDisabled
              ? 'opacity-80 cursor-not-allowed'
              : 'opacity-100 cursor-pointer hover:bg-zinc-200 dark:hover:bg-slate-400'
          )}
        >
          <div className='h-[36px] flex-cc p-2'>
            <PlusCircleLine16 />
          </div>
        </div>
      </DropdownV2.Trigger>

      <DropdownV2.Content
        side='left'
        sideOffset={-1}
        align='start'
        alignOffset={5}
        onInteractOutside={(e) => e.preventDefault()}
        onOpenAutoFocus={(e) => e.preventDefault()}
        className='w-[650px] text-m-m'
      >
        <Modal.Header onCloseClick={() => handleOpenChange(false)}>
          <Trans>New Column</Trans>
        </Modal.Header>
        <CreateColumnProvider id='mk-glide-add-col'>
          <ColumnForm
            onCancel={() => handleOpenChange(false)}
            onHide={() => handleOpenChange(false)}
          />
        </CreateColumnProvider>
      </DropdownV2.Content>
    </DropdownV2>
  )
}
